module.exports = "\r\n\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/announcement-components/create-announcement/create-announcement.component.css
// module id = ./src/app/announcement-components/create-announcement/create-announcement.component.css
// module chunks = main